"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTime = exports.Time = exports.Date = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTimeFormat_1 = require("../../utils/dateTimeFormat");
const Date = ({ value, isLocalTime }) => {
    const { locale } = (0, react_intl_1.useIntl)();
    moment_1.default.locale(locale);
    const datetime = isLocalTime ? moment_1.default.parseZone(value) : (0, moment_1.default)(value);
    return (react_1.default.createElement("span", null, datetime.format(dateTimeFormat_1.DATE_FORMAT)));
};
exports.Date = Date;
const Time = ({ value, isLocalTime }) => {
    const { locale } = (0, react_intl_1.useIntl)();
    moment_1.default.locale(locale);
    const datetime = isLocalTime ? moment_1.default.parseZone(value) : (0, moment_1.default)(value);
    return (react_1.default.createElement("span", null, datetime.format(dateTimeFormat_1.TIME_FORMAT)));
};
exports.Time = Time;
// TODO add config for only date/time configure and embed in other places with datetime displaying
// TODO add classes
const DateTime = (props) => {
    return (react_1.default.createElement("span", null,
        react_1.default.createElement(exports.Date, { ...props }),
        ", ",
        react_1.default.createElement(exports.Time, { ...props })));
};
exports.DateTime = DateTime;
//# sourceMappingURL=index.js.map